<template>
  <FaIcon :icon="['fas', HOLIDAY_SET_DEFAULT_ICON]" />
</template>

<script setup lang="ts">
import { HOLIDAY_SET_DEFAULT_ICON } from '@/constants/holiday-set';
</script>
